/* Winkelwagen bijwerken zonder de pagina te verlaten.

   De knoppen in de winkelwagen zijn gewone links naar /cart/change. Zonder
   JavaScript werkt dat, maar je verliest je plek: Shopify stuurt je na de
   wijziging ergens anders heen, en bij het weghalen van het laatste product
   beland je op een andere pagina dan waar je stond.

   Dit script vangt de klik af, doet dezelfde wijziging via /cart/change.js en
   tekent alleen de winkelwagen opnieuw. Het leest de regel en het aantal uit
   de href van de link, zodat er maar één plek is waar die logica staat: haalt
   het script het niet, dan doet de link precies hetzelfde.

   Werkt zowel op de winkelwagenpagina als in het zijpaneel — beide dragen
   data-cart-section met hun eigen sectie-id. */

(function () {
  'use strict';

  var teksten = window.ncStrings || {};
  var routes = (window.ncSettings && window.ncSettings.routes) || {};
  var bezig = false;

  function paramUit(href, naam) {
    try {
      return new URL(href, window.location.origin).searchParams.get(naam);
    } catch (e) {
      return null;
    }
  }

  /* De secties opnieuw ophalen via de Section Rendering API. Dat geeft precies
     dezelfde HTML als een volledige pagina, dus prijzen, de voortgangsbalk en
     de lege staat kloppen zonder dat dit script ze zelf hoeft na te rekenen.

     Álle winkelwagensecties, niet alleen die waarin je klikte: op de
     winkelwagenpagina staat het zijpaneel er ook, en dat bleef anders de
     verwijderde regel tonen tot je de pagina herlaadde. */
  function ververs() {
    var vakken = [].slice.call(document.querySelectorAll('[data-cart-section]'));
    var ids = vakken.map(function (v) { return v.dataset.cartSection; }).filter(Boolean);
    if (!ids.length) return Promise.resolve();

    return fetch(window.location.pathname + '?sections=' + encodeURIComponent(ids.join(',')))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data) return;
        vakken.forEach(function (vak) {
          var id = vak.dataset.cartSection;
          if (!data[id]) return;
          var nieuw = new DOMParser().parseFromString(data[id], 'text/html');
          var bron = nieuw.querySelector('[data-cart-section="' + id + '"]');
          if (bron) vak.innerHTML = bron.innerHTML;
        });
      });
  }

  /* De teller in de kop staat al in theme.js; hier alleen aanroepen, anders
     staan er twee plekken die hetzelfde doen en lopen ze ooit uiteen. */
  function tellers() {
    if (window.ncCart && window.ncCart.tellerBijwerken) {
      return window.ncCart.tellerBijwerken();
    }
    return Promise.resolve();
  }

  /* Geen kortingscode-afhandeling hier, met opzet.

     Shopify heeft één manier om een code op de winkelwagen zelf toe te passen:
     /discount/CODE. Die is gemeten op deze winkel en hij is gevaarlijk — bij
     een code die niet bestaat blijft het cart-token gelijk maar zijn de regels
     weg. Eén typefout kost dan de hele bestelling.

     Het veld staat daarom gewoon in het winkelwagenformulier en reist mee naar
     het afrekenen, waar Shopify de code wél veilig controleert. Dat vraagt
     geen JavaScript en kan niets stukmaken. Ga hier niet alsnog /discount/
     aanroepen omdat het bedrag dan eerder zichtbaar is; dat is de afweging die
     hier bewust is gemaakt. */

  /* Iets toegevoegd vanuit de aanraders? Dan hoort de wagen mee te veranderen.
     Tijdens onze eigen wijziging niet: die ververst zichzelf al. */
  document.addEventListener('nc:cart:updated', function () {
    if (bezig) return;
    if (!document.querySelector('[data-cart-section]')) return;
    ververs();
  });

  /* Kortingscode weghalen. De link werkt op zichzelf al — hij laadt /cart
     opnieuw — maar dan spring je naar boven en ben je je plek kwijt. Hier
     wordt hij afgevangen zodat alleen de winkelwagen opnieuw getekend wordt. */
  document.addEventListener('click', function (e) {
    var weg = e.target.closest('[data-korting-weg]');
    if (!weg || !weg.href || bezig) return;

    e.preventDefault();
    bezig = true;
    var vak = weg.closest('[data-cart-section]');
    if (vak) vak.classList.add('is-bezig');

    fetch(weg.href, { credentials: 'same-origin' })
      .then(function () { return Promise.all([ververs(), tellers()]); })
      .catch(function () { window.location.href = weg.href; })
      .then(function () {
        bezig = false;
        document.querySelectorAll('[data-cart-section]').forEach(function (v) {
          v.classList.remove('is-bezig');
        });
      });
  });

  document.addEventListener('click', function (e) {
    var link = e.target.closest('.cart__qty-button, .cart__item-remove');
    if (!link || !link.href) return;

    var vak = link.closest('[data-cart-section]');
    if (!vak) return;

    var regel = paramUit(link.href, 'line');
    var aantal = paramUit(link.href, 'quantity');
    if (regel === null || aantal === null) return; // geen wijzigingslink: laat de browser gaan

    e.preventDefault();
    if (bezig) return;
    bezig = true;

    /* Alleen de regel waar je op klikt reageert. Eerder werd het hele paneel
       gedimd; dan vervaagt bij het weghalen van één product de complete
       winkelwagen, inclusief wat er blijft staan, en dat leest als een storing.

       Weghalen krijgt een andere behandeling dan een aantal wijzigen: het een
       verdwijnt, het ander wacht even. Vind ik de regel niet — een knop buiten
       een regel, of markup die verandert — dan alsnog het paneel, want zonder
       enige terugkoppeling lijkt een klik niet aangekomen. */
    var regelEl = link.closest('.cart__item');
    if (regelEl) {
      regelEl.classList.add(Number(aantal) === 0 ? 'is-weg' : 'is-wacht');
    } else {
      vak.classList.add('is-bezig');
    }

    fetch((routes.cartChange || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(regel), quantity: Number(aantal) })
    })
      .then(function (r) {
        if (!r.ok) throw new Error(teksten.cartError || 'Er ging iets mis.');
        return Promise.all([ververs(), tellers()]);
      })
      .catch(function () {
        // Lukt het niet, dan alsnog langs de gewone weg: beter een sprong naar
        // een andere pagina dan een knop die niets doet.
        window.location.href = link.href;
      })
      .then(function () {
        bezig = false;
        // De regel zelf is met de nieuwe lijst meegekomen en bestaat niet meer;
        // het paneel opruimen kan geen kwaad als het er niet op stond.
        vak.classList.remove('is-bezig');
      });
  });
})();
